module.exports = __webpack_public_path__ + "e3bf50b590dcb1c535b9934814893196.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/credits.png
// module id = 409
// module chunks = 0